export const GET_ALL_EVENT_DATA = 'GET_ALL_EVENT_DATA';
